title: Itinerary Locations
generateAiContent: Generate AI Content
regenerateAiContent: Regenerate AI Content
create:
  title: Create Itinerary Location
  duplicateDialog:
    title: A location already exists for {{ existingLocationName }}
    body: You can either edit that location instead, or search for another place.
    accept: Edit Existing
    reject: Search
update:
  title: Edit Itinerary Location
sort:
  -modified: Newest
  name: A-Z
  -name: Z-A
aiText: AI Text
aiTextEdited: AI Text (Edited)